import { FILTER_TYPES } from 'src/constants/chat';

export const filterChats = (chats, contacts, searchText, filterType) => {
  let filteredChats = [...chats.allKeys]; // Start with API order

  if (searchText) {
    const norm = searchText.trim().toLowerCase();
    const digits = norm.replace(/\D/g, '');

    // Create a Set of matching chat keys for O(1) lookup
    const matchingKeys = new Set();

    // First pass: identify all matching chats
    filteredChats.forEach((chatKey) => {
      const chat = chats.byKey[chatKey];

      const hasMatch = chat.participantIds.some((id) => {
        const contact = contacts.byId[id] || {};
        const firstName = contact.firstName || '';
        const lastName = contact.lastName || '';
        const fullName = `${firstName} ${lastName}`.trim().toLowerCase();

        // Name match?
        const nameMatch = fullName.includes(norm);

        // Phone match?
        const phoneMatch = Boolean(digits)
          && ['phone1', 'phone2', 'phone3'].some((field) => {
            const raw = contact[field] || '';
            return raw.replace(/\D/g, '').includes(digits);
          });

        return nameMatch || phoneMatch;
      });

      if (hasMatch) {
        matchingKeys.add(chatKey);
      }
    });

    // Second pass: filter while preserving original order
    filteredChats = filteredChats.filter((chatKey) => matchingKeys.has(chatKey));
  }

  if (filterType === FILTER_TYPES.unread) {
    filteredChats = filteredChats.filter((chatKey) => {
      const chat = chats.byKey[chatKey];
      return chat.unreadCount > 0;
    });
  }

  return filteredChats;
};

export const sortChatsBySocketDateReceived = (chats, chatKeys, contacts) => {
  if (!chats || !chats.byKey || !chatKeys || chatKeys.length === 0) {
    return chatKeys || [];
  }

  // Separate chats into three groups: pinned always first
  const pinnedChats = [];
  const chatsWithSocket = [];
  const chatsWithoutSocket = [];

  chatKeys.forEach((key) => {
    const chat = chats.byKey[key];
    const contactId = chat?.participantIds?.[0];
    const contact = contactId && contacts?.byId ? contacts.byId[String(contactId)] : null;
    const isPinned = contact?.chatPreferences?.isPinned;

    if (isPinned) {
      pinnedChats.push(key);
    } else if (chat?.socketDateReceived) {
      chatsWithSocket.push(key);
    } else {
      chatsWithoutSocket.push(key);
    }
  });

  // Sort chats with socketDateReceived by that timestamp (most recent first)
  chatsWithSocket.sort((aKey, bKey) => {
    const aTime = new Date(chats.byKey[aKey].socketDateReceived).getTime();
    const bTime = new Date(chats.byKey[bKey].socketDateReceived).getTime();
    return bTime - aTime; // DESC
  });

  // Pinned first (backend order preserved), then socket, then rest
  return [...pinnedChats, ...chatsWithSocket, ...chatsWithoutSocket];
};
